"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var React = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _Info = _interopRequireDefault(require("../Info"));

var _Radio = _interopRequireDefault(require("./Radio"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var RadioGroup = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(RadioGroup, _Component);

  var _super = _createSuper(RadioGroup);

  function RadioGroup() {
    var _this;

    (0, _classCallCheck2["default"])(this, RadioGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(RadioGroup, [{
    key: "renderContent",
    value: function renderContent() {
      var _this2 = this;

      var _this$props = this.props,
          selectedValue = _this$props.selectedValue,
          onSelected = _this$props.onSelected,
          disabled = _this$props.disabled,
          itemStyle = _this$props.itemStyle;
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.options.map(function (option) {
        var selected = option.props.value == selectedValue;
        return /*#__PURE__*/React.createElement("div", {
          className: (0, _styling.css)(_this2.styles.item, itemStyle),
          key: "radio_".concat(option.props.value)
        }, /*#__PURE__*/React.createElement("div", {
          className: (0, _styling.css)(_this2.styles.itemTitle),
          onClick: !disabled ? function () {
            return onSelected(option.props.value);
          } : undefined
        }, /*#__PURE__*/React.createElement("div", {
          className: (0, _styling.css)(_this2.styles.radioLabel)
        }, /*#__PURE__*/React.createElement(_Radio["default"], {
          className: (0, _styling.css)(_this2.styles.radio),
          checked: selected
        }), /*#__PURE__*/React.createElement("div", {
          className: (0, _styling.css)(_this2.styles.title, option.props.className),
          style: {
            opacity: selected ? 1 : 0.8
          }
        }, typeof option.props.text === "string" ? option.props.text : option.props.text())), option.props.description && /*#__PURE__*/React.createElement(_Info["default"], {
          text: option.props.description,
          popoverMaxWidth: 200,
          sentiment: "info",
          className: (0, _styling.css)(_this2.styles.info)
        })), option.props.children);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          style = _this$props2.style;
      var rootCSS = (0, _styling.css)(this.styles.root, style, className);
      return /*#__PURE__*/React.createElement("div", {
        className: rootCSS
      }, this.renderContent());
    }
  }, {
    key: "options",
    get: function get() {
      var children = this.props.children;
      var optionChildren = React.Children.toArray(children).filter(function (e) {
        return /*#__PURE__*/React.isValidElement(e) && e.type.name == RadioGroup.Item.name;
      });
      return optionChildren;
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$context$theming = this.context.theming,
          textDark = _this$context$theming.theme.textDark,
          fonts = _this$context$theming.fonts;
      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          layout = _this$props3.layout;
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: layout == "vertical" ? "column" : "row"
        },
        item: {
          cursor: disabled ? "default" : "pointer",
          display: "flex",
          flexDirection: "column",
          margin: layout == "vertical" ? "0px 0px 13px 0px" : "0px 20px 0px 0px"
        },
        itemTitle: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        },
        title: {
          fontSize: 16,
          color: textDark,
          fontFamily: fonts.semibold,
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          userSelect: "none",
          transition: "opacity 0.2s linear",
          ":hover": {
            opacity: !disabled ? 1 : undefined
          }
        },
        radio: {
          marginRight: 8
        },
        radioLabel: {
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          opacity: disabled ? 0.6 : 1
        },
        info: {
          marginLeft: 10,
          opacity: 1
        }
      });
    }
  }]);
  return RadioGroup;
}(React.Component), _class3.contextType = _providers.LegoContext, _class3.Item = function () {
  return null;
}, _class3.demoProps = {
  onSelected: function onSelected() {},
  selectedValue: 2,
  layout: "vertical"
}, _class3.defaultProps = {
  layout: "vertical"
}, _class3.propDoc = {
  onSelected: {
    required: true,
    type: "(value: any) => mixed",
    description: "Callback for when an item is selected"
  },
  selectedValue: {
    required: true,
    type: "any",
    description: "Currently selected item"
  },
  disabled: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates the input is disabled. " + "Set this value when submitting a form to prevent modification"
  },
  layout: {
    required: false,
    defaultValue: "vertical",
    type: "vertical | horizontal",
    description: "Layout direction of the options"
  }
}, _class3.demoRender = "\n  <RadioGroup\n    onSelected={() => {}}\n    popoverContent={\n      \"Company name must be consistent with name on Business License.\"\n    }\n    selectedValue={2}\n  >\n    <RadioGroup.Item value={1} text=\"Proof of your ID\" />\n    <RadioGroup.Item\n      value={2}\n      text=\"Proof of ownership of your online store URL\"\n    />\n  </RadioGroup>\n", _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "options", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "options"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = RadioGroup;
exports["default"] = _default;